export default __webpack_public_path__ + "static/media/6201121d303cd3ae.23fd778560a36adcf93c914eca1b6c23.svg";